module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-breadcrumb', {
    staticClass: "bread",
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'advertiseManager'
      }
    }
  }, [_vm._v("广告管理")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("修改广告")])], 1), _vm._v(" "), _c('div', [_c('el-form', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.formloading),
      expression: "formloading"
    }],
    ref: "advForm",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.advForm,
      "rules": _vm.advrules,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "广告名称",
      "prop": "advertiseName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "广告名称"
    },
    model: {
      value: (_vm.advForm.advertiseName),
      callback: function($$v) {
        _vm.$set(_vm.advForm, "advertiseName", $$v)
      },
      expression: "advForm.advertiseName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "广告类型",
      "prop": "typeName"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "类型"
    },
    on: {
      "change": function($event) {
        _vm.getfindtype(true)
      }
    },
    model: {
      value: (_vm.advForm.typeName),
      callback: function($$v) {
        _vm.$set(_vm.advForm, "typeName", $$v)
      },
      expression: "advForm.typeName"
    }
  }, _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.typeName,
        "value": item.typeId
      }
    })
  }), 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.matFlag),
      expression: "matFlag"
    }]
  }, [_vm._v("    广告尺寸：" + _vm._s(_vm.advForm.materialW) + "*" + _vm._s(_vm.advForm.materialH))])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "广告类型",
      "prop": "fodderW"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "类型"
    },
    on: {
      "change": function($event) {
        _vm.getfindtype('')
      }
    },
    model: {
      value: (_vm.advForm.fodderW),
      callback: function($$v) {
        _vm.$set(_vm.advForm, "fodderW", $$v)
      },
      expression: "advForm.fodderW"
    }
  }, _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.fodderW,
        "value": item.typeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "广告类型",
      "prop": "fodderW"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "类型"
    },
    on: {
      "change": function($event) {
        _vm.getfindtype('')
      }
    },
    model: {
      value: (_vm.advForm.fodderH),
      callback: function($$v) {
        _vm.$set(_vm.advForm, "fodderH", $$v)
      },
      expression: "advForm.fodderH"
    }
  }, _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.fodderH,
        "value": item.typeId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "fileList"
    }
  }, [_c('el-upload', {
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.uploadurl,
      "data": _vm.upload_data,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemove,
      "limit": 3,
      "on-success": _vm.handleSuccess,
      "before-upload": _vm.handletype,
      "file-list": _vm.advForm.fileList
    }
  }, [_c('span', {
    class: {
      isable: _vm.isorno
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("大小不超过100MB")])], 1)])], 1), _vm._v(" "), (_vm.typeFlag) ? _c('el-form-item', {
    attrs: {
      "label": "跳转类型",
      "prop": "targetType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "跳转目标类型"
    },
    on: {
      "change": function($event) {
        _vm.istargetType()
      }
    },
    model: {
      value: (_vm.advForm.targetType),
      callback: function($$v) {
        _vm.$set(_vm.advForm, "targetType", $$v)
      },
      expression: "advForm.targetType"
    }
  }, [_c('el-option', {
    attrs: {
      "value": "0",
      "label": "无"
    }
  }, [_vm._v("无")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "1",
      "label": "商品"
    }
  }, [_vm._v("商品")]), _vm._v(" "), _c('el-option', {
    attrs: {
      "value": "2",
      "label": "品类"
    }
  }, [_vm._v("品类")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.advForm.targetType === "4" && _vm.advForm.pageType === "float"),
      expression: "advForm.targetType ===\"4\" && advForm.pageType === \"float\""
    }],
    attrs: {
      "prop": "hrefList"
    }
  }, [_c('el-upload', {
    ref: "uploadHref",
    staticClass: "upload-demo",
    attrs: {
      "action": _vm.uploadurl,
      "data": _vm.upload_data,
      "on-preview": _vm.handlePreview,
      "on-remove": _vm.handleRemoveHref,
      "limit": 3,
      "on-success": _vm.hrefSuccess,
      "before-upload": _vm.hrefType,
      "file-list": _vm.advForm.hrefList
    }
  }, [_c('span', {
    class: {
      isable: _vm.isornohref
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "success"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("大小不超过100MB")])], 1)])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ishref),
      expression: "ishref"
    }],
    attrs: {
      "label": "跳转目标",
      "prop": "href"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "30%"
    },
    attrs: {
      "placeholder": "跳转目标"
    },
    model: {
      value: (_vm.advForm.href),
      callback: function($$v) {
        _vm.$set(_vm.advForm, "href", $$v)
      },
      expression: "advForm.href"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isgoods),
      expression: "isgoods"
    }],
    attrs: {
      "label": "跳转目标",
      "prop": "goodsList"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "跳转目标"
    },
    model: {
      value: (_vm.advForm.ID),
      callback: function($$v) {
        _vm.$set(_vm.advForm, "ID", $$v)
      },
      expression: "advForm.ID"
    }
  }, _vm._l((_vm.goodsList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.productName,
        "value": item.productId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isclassify),
      expression: "isclassify"
    }],
    attrs: {
      "label": "跳转目标",
      "prop": "classifyList"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "分类"
    },
    model: {
      value: (_vm.ID),
      callback: function($$v) {
        _vm.ID = $$v
      },
      expression: "ID"
    }
  }, _vm._l((_vm.classifyList), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.categoryName,
        "value": item.categoryId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('video', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    staticStyle: {
      "width": "200px",
      "height": "200px"
    },
    attrs: {
      "id": "video",
      "src": _vm.videoFile
    }
  }), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.isDisabled
    },
    on: {
      "click": function($event) {
        _vm.submitForm('advForm')
      }
    }
  }, [_vm._v("确 定")])], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "广告名称",
      "prop": "advName"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "机构名称"
    },
    model: {
      value: (_vm.advForm.advName),
      callback: function($$v) {
        _vm.$set(_vm.advForm, "advName", $$v)
      },
      expression: "advForm.advName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "id",
      "prop": "advertiseId"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "id"
    },
    model: {
      value: (_vm.advForm.advertiseId),
      callback: function($$v) {
        _vm.$set(_vm.advForm, "advertiseId", $$v)
      },
      expression: "advForm.advertiseId"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "图片",
      "prop": "imgUrl"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "imgUrl"
    },
    model: {
      value: (_vm.advForm.imgUrl),
      callback: function($$v) {
        _vm.$set(_vm.advForm, "imgUrl", $$v)
      },
      expression: "advForm.imgUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "视频",
      "prop": "videoUrl"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "videoUrl"
    },
    model: {
      value: (_vm.advForm.videoUrl),
      callback: function($$v) {
        _vm.$set(_vm.advForm, "videoUrl", $$v)
      },
      expression: "advForm.videoUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "视频",
      "prop": "audioUrl"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "placeholder": "audioUrl"
    },
    model: {
      value: (_vm.advForm.audioUrl),
      callback: function($$v) {
        _vm.$set(_vm.advForm, "audioUrl", $$v)
      },
      expression: "advForm.audioUrl"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4adbdc0e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/market/AdvertiseModify.vue
// module id = 1061
// module chunks = 2